import { t } from "i18next";
import React, { useEffect, useRef, useState } from "react";
import "./PeriodInput.scss";

interface IPeriodInput {
  periodSelected: string;
  setPeriodSelected: React.Dispatch<React.SetStateAction<string>>;
}

const PeriodInput = ({ periodSelected, setPeriodSelected }: IPeriodInput) => {
  const wrapperRef = useRef(null);
  const [modalOpen, setModalOpen] = useState(false);

  const handleSelectCategory = (item: string) => {
    setPeriodSelected(item);
    setModalOpen(false);
  };

  const handleOpenModal = () => {
    setModalOpen((prev) => !prev);
  };

  const handleTapOutside = (event: MouseEvent | TouchEvent) => {
    if (
      wrapperRef.current &&
      !(wrapperRef.current as HTMLElement).contains(event.target as Node)
    ) {
      setModalOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleTapOutside);
    document.addEventListener("touchstart", handleTapOutside);
    return () => {
      document.removeEventListener("mousedown", handleTapOutside);
      document.removeEventListener("touchstart", handleTapOutside);
    };
  }, []);
  return (
    <div className="u-i-p-control-item-holder-bc" ref={wrapperRef}>
      <div className="multi-select-bc ">
        <div className="form-control-bc valid filled">
          <div
            className="form-control-label-bc inputs"
            onClick={handleOpenModal}
          >
            {periodSelected === "custom" ? (
              <div className="form-control-select-bc ellipsis">
                {t("admin.Custom")}
              </div>
            ) : (
              <div className="form-control-select-bc ellipsis">
                {periodSelected} {t("admin.hours")}
              </div>
            )}
            <i
              className={`form-control-icon-bc bc-i-small-arrow-${
                modalOpen ? "up" : "down"
              }`}
            />
            <i className="form-control-input-stroke-bc" />
            <span className="form-control-title-bc ellipsis">
              {t("admin.Period")}
            </span>
          </div>
          {modalOpen ? (
            <div className="multi-select-label-bc">
              <label
                className={`checkbox-control-content-bc ${
                  periodSelected === "1" ? "active" : ""
                } `}
                data-option-value={1}
                onClick={() => handleSelectCategory("1")}
              >
                <p
                  className="checkbox-control-text-bc"
                  style={{ pointerEvents: "none" }}
                >
                  1 {t("admin.hours")}
                </p>
              </label>
              <label
                className={`checkbox-control-content-bc ${
                  periodSelected === "2" ? "active" : ""
                } `}
                data-option-value={2}
                onClick={() => handleSelectCategory("2")}
              >
                <p
                  className="checkbox-control-text-bc"
                  style={{ pointerEvents: "none" }}
                >
                  2 {t("admin.hours")}
                </p>
              </label>
              <label
                className={`checkbox-control-content-bc ${
                  periodSelected === "3" ? "active" : ""
                } `}
                data-option-value={3}
                onClick={() => handleSelectCategory("3")}
              >
                <p
                  className="checkbox-control-text-bc"
                  style={{ pointerEvents: "none" }}
                >
                  3 {t("admin.hours")}
                </p>
              </label>
              <label
                className={`checkbox-control-content-bc ${
                  periodSelected === "6" ? "active" : ""
                } `}
                data-option-value={6}
                onClick={() => handleSelectCategory("6")}
              >
                <p
                  className="checkbox-control-text-bc"
                  style={{ pointerEvents: "none" }}
                >
                  6 {t("admin.hours")}
                </p>
              </label>
              <label
                className={`checkbox-control-content-bc ${
                  periodSelected === "12" ? "active" : ""
                } `}
                data-option-value={12}
                onClick={() => handleSelectCategory("12")}
              >
                <p
                  className="checkbox-control-text-bc"
                  style={{ pointerEvents: "none" }}
                >
                  12 {t("admin.hours")}
                </p>
              </label>
              <label
                className={`checkbox-control-content-bc ${
                  periodSelected === "24" ? "active" : ""
                } `}
                data-option-value={24}
                onClick={() => handleSelectCategory("24")}
              >
                <p
                  className="checkbox-control-text-bc"
                  style={{ pointerEvents: "none" }}
                >
                  24 {t("admin.hours")}
                </p>
              </label>
              <label
                className={`checkbox-control-content-bc ${
                  periodSelected === "48" ? "active" : ""
                } `}
                data-option-value={48}
                onClick={() => handleSelectCategory("48")}
              >
                <p
                  className="checkbox-control-text-bc"
                  style={{ pointerEvents: "none" }}
                >
                  48 {t("admin.hours")}
                </p>
              </label>
              <label
                className={`checkbox-control-content-bc ${
                  periodSelected === "72" ? "active" : ""
                } `}
                data-option-value={72}
                onClick={() => handleSelectCategory("72")}
              >
                <p
                  className="checkbox-control-text-bc"
                  style={{ pointerEvents: "none" }}
                >
                  72 {t("admin.hours")}
                </p>
              </label>
              <label
                className={`checkbox-control-content-bc ${
                  periodSelected === "custom" ? "active" : ""
                } `}
                data-option-value=""
                onClick={() => handleSelectCategory("custom")}
              >
                <p
                  className="checkbox-control-text-bc"
                  style={{ pointerEvents: "none" }}
                >
                  {t("admin.Custom")}
                </p>
              </label>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export { PeriodInput };
